import React, { useRef } from "react";
import { QuantityChooser, useFlowData, getFlowDataDirect } from "@adaptis/flow-components";
import { addNewPet, removeLastPet, getPetQty } from "../../util/data-store";
import { IPetQuantityProps } from "./PetQuantity.types";
import { PetType, Pets } from "../../util/common-types";
import "./PetQuantity.scss";

export default function PetQuantity(props: IPetQuantityProps) {
  const { setData, getData } = useFlowData();
  const petsRef = useRef<Pets>(props.data ?? []);

  const quantityRef = useRef({
    dogQty: 0,
    catQty: 0,
    total: 0,
  });
  updateQty();

  function sendDataUpdateMessage(dogQty: number, catQty: number) {
    if (
      dogQty === quantityRef.current.dogQty &&
      catQty === quantityRef.current.catQty
    )
      return;

    setData(props.dataField ?? "", petsRef.current);
  }

  function addPet(petType: PetType) {
    addNewPet(petsRef.current, petType);
    updateQty();
    setData("petQty", quantityRef.current.total);

    setPetTypesChosen(petType, "add");
  }

  function removePet(petType: PetType) {
    removeLastPet(petsRef.current, petType);
    updateQty();
    setData("petQty", quantityRef.current.total);

    setPetTypesChosen(petType, "remove");

    checkRemovedQuote();
  }
  function checkRemovedQuote() {
    let allPets = getFlowDataDirect("pets");
    //quote slug
    let quoteSlug = (getData("root.quote-slug") || "").split("/");
    let quoteId = quoteSlug[quoteSlug.length - 1];
    let checkExist = allPets.find((item: any) => item.id === quoteId);
    if (!checkExist) {
      setData("root.quote-slug", "");
    }
  }

  function setPetTypesChosen(petType: PetType, method: string) {

    let prevPetTypes = getData("root.PetTypesChosen");

    if (method == "add") {

      if (!prevPetTypes) prevPetTypes = new Array<string>();

      if (prevPetTypes) {
        let arrayprevPetTypes = prevPetTypes as Array<string>;
        arrayprevPetTypes.push(petType);
        setData("root.PetTypesChosen", arrayprevPetTypes);
      }

    } else {

      if (!prevPetTypes) prevPetTypes = new Array<string>();

      if (prevPetTypes.length > 0) {
        let arrayprevPetTypes = prevPetTypes as Array<string>;

        let countPetType = arrayprevPetTypes.filter((e) => e == petType);
        let isPetTheFirstChosen = arrayprevPetTypes[0] == petType;
        let i = 0;
        let hasBeenRemoved = false;

        if (isPetTheFirstChosen && countPetType && countPetType.length > 1) {
          arrayprevPetTypes.forEach(function (item) {
            if (i > 0 && item == petType && !hasBeenRemoved) {
              arrayprevPetTypes.splice(i, 1);
              hasBeenRemoved = true;
            }
            i++;
          });
        } else {
          arrayprevPetTypes.forEach(function (item) {
            if (item == petType && !hasBeenRemoved) {
              arrayprevPetTypes.splice(i, 1);
              hasBeenRemoved = true;
            }
            i++;
          });
        }
      }
    }

    prevPetTypes = getData("root.PetTypesChosen");

    if (prevPetTypes.length > 0)
      setData("root.PetTypeChosenFirst", prevPetTypes[0]);
  }

  function updateQty() {
    quantityRef.current = getPetQty(petsRef.current);
  }

  return (
    <div data-testid="PetQuantity" className="flc_pet-quantity">
      <QuantityChooser
        className="qty-chooser"
        itemName={props.dogPropmt}
        image={props.dogImage}
        imageSelected={props.dogSelectedImage}
        totalQty={quantityRef.current.total}
        value={quantityRef.current.dogQty}
        onChange={(qty) => {
          sendDataUpdateMessage(qty, quantityRef.current.catQty);
          if (quantityRef.current.dogQty < qty) {
            addPet(PetType.Dog);
          } else if (quantityRef.current.dogQty > qty) {
            removePet(PetType.Dog);
          }
        }}
      />
      <div className="spacer"></div>
      <QuantityChooser
        className="qty-chooser"
        itemName={props.catPropmt}
        image={props.catImage}
        imageSelected={props.catSelectedImage}
        totalQty={quantityRef.current.total}
        value={quantityRef.current.catQty}
        onChange={(qty) => {
          sendDataUpdateMessage(quantityRef.current.dogQty, qty);
          if (quantityRef.current.catQty < qty) {
            addPet(PetType.Cat);
          } else if (quantityRef.current.catQty > qty) {
            removePet(PetType.Cat);
          }
        }}
      />
    </div>
  );
}
